export default {
  "boardOperations": "Opérations du Bureau",
  "manageDailyAssignmentsWorkflowAndCompletionStatus": "Gérer les tâches quotidiennes, le flux de travail et l'état d'achèvement.",
  "generateBoard": "Générer de la carte",
  "newTask": "Nouvelle tâche",
  "myTasks": "Mes tâches",
  "staffProfileUnavailable": "(profil du personnel non disponible)",
  "boardNotGeneratedYet": "Tableau n'a pas encore été généré",
  "loading": "Chargement…",
  "noWorkOrders": "Pas d'ordre de travail.",
  "staffWorkload": "Effectifs du personnel",
  "noStaffAssignmentsYet": "Pas encore d'affectations de personnel.",
  "selectedRoute": "Voie choisie",
  "selectAStaffMemberToReorderTheirRoute": "Sélectionnez un membre du personnel pour réorganiser son parcours.",
  "roomStatus": "État de la salle",
  "allOccupancy": "Toutes les occupations",
  "vacant": "Vacants",
  "occupied": "occupés",
  "reserved": "Réservé",
  "outOfOrder": "Hors de la commande",
  "outOfService": "Hors service",
  "housekeeping": "Entretien ménager",
  "allHousekeeping": "Entretien ménager",
  "ready": "Prêt",
  "needsCleaning": "Nettoyage des besoins",
  "inProgress": "En cours",
  "inspectionPending": "Inspection en cours",
  "blocked": "Bloqué",
  "allRoomsCurrentlyReady": "Toutes les chambres sont actuellement prêtes.",
  "housekeepingStaff": "Personnel de ménage",
  "manageTheStaffRosterAvailableForHousekeepingTaskAssignment": "Gérer le fichier du personnel disponible pour l ' affectation des tâches de ménage.",
  "searchHousekeepingStaff": "Rechercher du personnel de ménage",
  "addStaff": "Ajouter le personnel",
  "staff": "Personnel",
  "active": "Actif",
  "inactive": "Inactif",
  "edit": "Modifier",
  "deactivate": "Désactiver",
  "reactivate": "Réactivez",
  "noHousekeepingStaffRosterEntriesYet": "Il n ' y a pas encore d ' inscription sur la liste des fonctionnaires chargés de l ' entretien.",
  "addHousekeepingStaff": "Ajouter le personnel chargé de l ' entretien",
  "selectFromClubStaffAndAddToTheHousekeepingRoster": "Choisissez parmi le personnel du club et ajoutez à la liste de tenue de maison.",
  "searchStaff": "Personnel de recherche",
  "noMatchingStaff": "Pas de personnel assorti.",
  "shiftPreference": "Préférence du mouvement",
  "any": "ANY",
  "am": "AM",
  "pm": "PM",
  "notes": "Notes",
  "cancel": "Annuler",
  "editHousekeepingStaff": "Modifier l ' état-major",
  "updateHousekeepingSpecificRosterSettings": "Mettre à jour les paramètres de fichier propres à la maison.",
  "displayOrder": "Ordre d’affichage",
  "save": "Enregistrer",
  "newWorkOrder": "Nouvelle commande de travail",
  "createAnAdHocOrPublicAreaTaskForTheBoard": "Créer une tâche spéciale ou publique pour le conseil.",
  "selectType": "Sélectionnez le type",
  "roomCode": "Code de chambre",
  "eG1204": "Par exemple, 1204",
  "selectPriority": "Sélectionnez la priorité",
  "high": "Élevé",
  "medium": "Moyen",
  "low": "Faible",
  "estimatedMinutes": "Minutes estimées",
  "dueAt": "Sommes dues",
  "createTask": "Créer une tâche",
  "assignStaff": "Personnel affecté aux missions",
  "start": "Commencez",
  "block": "Bloquer",
  "complete": "Complet",
  "inspect": "Inspective",
  "clear": "Effacer",
  "up": "Debout",
  "down": "En bas.",
  "unassigned": "Non attribué",
  "assigned": "Affecté",
  "needsInspection": "Inspection des besoins",
  "done": "Terminé",
  "closed": "Fermé",
  "adHoc": "L ' ad hoc",
  "publicArea": "Secteur public",
  "deepClean": "Profondeur propre",
  "maintenance": "Maintenance",
  "inspection": "Inspection",
  "checkout": "Paiement",
  "stayover": "Séjour en cours",
  "room": "Chambre",
  "nA": "N/A",
  "invalid": "Invalide",
  "addABlockingNoteOptional": "Ajouter une note de blocage (facultatif):",
  "didTheRoomPassInspection": "Est-ce que la pièce a fait l'inspection ?",
  "inspectionNotesOptional": "Notes d ' inspection (facultatif):",
  "editTask": "Éditer la tâche",
  "newHousekeepingTask": "Nouvelle tâche de ménage",
  "roomNumber": "Salle {number}",
  "assignedStaff": "Personnel affecté",
  "scheduledTime": "Heure prévue",
  "serviceType": "Type de service",
  "dailyCleaning": "Nettoyage quotidien",
  "checkoutCleaning": "Checkout Nettoyage",
  "deepCleaning": "Nettoyage profond",
  "pending": "En attente",
  "completed": "Terminé",
  "onHold": "Attends.",
  "urgent": "Urgence",
  "updateTask": "Mettre à jour la tâche",
  "housekeepingBoard": "Pension de garde",
  "visualBoardOfRoomStatusesAndCleaningTasks": "Carte visuelle des statuts de chambre et des tâches de nettoyage.",
  "noHousekeepingTasksFound": "Aucune tâche de ménage n'a été trouvée.",
  "createFirstTask": "Créer une première tâche",
  "searchingStaff": "Le personnel de recherche...",
  "typeAtLeast2CharactersToSearch": "Saisissez au moins 2 caractères pour rechercher.",
  "noResultsFound": "Aucun résultat trouvé.",
  "boardName": "Conseil : {name}",
  "dueDate": "Sommes dues: {date}",
  "assignedName": "Assigné: {name}",
  "shiftShiftOrderOrder": "Vol: {shift} • Commande: {order}",
  "countMinutesMin": "{count} • {minutes} min",
  "unableToCompleteThisHousekeepingRequestPleaseTryAgain": "Incapable de remplir cette demande de ménage. Veuillez réessayer.",
  "staffSearchIsUnavailablePleaseTryAgain": "La recherche du personnel est indisponible. Veuillez réessayer.",
  "errors": {
    "invalid_request": "Demande de ménage invalide.",
    "room_not_found": "La chambre n'est pas trouvée.",
    "not_found": "Le dossier de ménage n'a pas été trouvé.",
    "invalid_status": "Statut invalide.",
    "invalid_status_transition": "Cette transition de statut n'est pas autorisée.",
    "staff_not_found": "Le fonctionnaire n'a pas été trouvé.",
    "board_required": "Générer un conseil avant d'attribuer le travail.",
    "invalid_shift_preference": "Préférence invalide.",
    "invalid_display_order": "Entrez une commande d'affichage valide.",
    "no_updates": "Pas de changement pour Enregistrer."
  },
  "enums": {
    "status": {
      "queued": "Non attribué",
      "assigned": "Affecté",
      "in_progress": "En cours",
      "blocked": "Bloqué",
      "needs_inspection": "Inspection des besoins",
      "done": "Terminé",
      "closed": "Fermé",
      "pending": "En attente",
      "completed": "Terminé",
      "on_hold": "Attends.",
      "ready": "Prêt",
      "needs_cleaning": "Nettoyage des besoins",
      "inspected": "Inspection en cours",
      "cancelled": "Annulé"
    },
    "type": {
      "ad_hoc": "L ' ad hoc",
      "public_area": "Secteur public",
      "deep_clean": "Profondeur propre",
      "maintenance": "Maintenance",
      "inspection": "Inspection",
      "checkout": "Paiement",
      "stayover": "Séjour en cours",
      "daily_cleaning": "Nettoyage quotidien",
      "checkout_cleaning": "Checkout Nettoyage",
      "deep_cleaning": "Nettoyage profond",
      "checkout_clean": "Commander propre",
      "stayover_clean": "Rester propre",
      "arrival_refresh": "Rafraîchissement"
    },
    "priority": {
      "high": "Élevé",
      "medium": "Moyen",
      "low": "Faible",
      "urgent": "Urgence"
    },
    "occupancy": {
      "vacant": "Vacants",
      "occupied": "occupés",
      "reserved": "Réservé",
      "out_of_order": "Hors de la commande",
      "out_of_service": "Hors service"
    },
    "shift": {
      "ANY": "N'importe quoi.",
      "AM": "AM",
      "PM": "PM"
    }
  },
  "status": "Statut",
  "type": "Type",
  "priority": "Priorité",
  "occupancy": "Occupation",
  "shift": "Décalage",
  "boardDate": "Date du Conseil",
  "requiredField": "Remplissez ce champ requis.",
  "generatedBoardName": "Conseil d'administration {date} {shift}"
};
